export const CHECKLIST = {
  title: "The kitchen-table checklist",
  intro:
    "Print this, pour the tea, and go through it together. Tick what you can find, circle what you can't. The circles are the plan.",
  groups: [
    {
      t: "Identity & legal",
      items: ["Birth certificates and passports", "Marriage, divorce or civil partnership papers", "The will — and where the signed original lives", "Power of attorney (financial and health)", "Living will or advance directive", "Social security / national ID numbers"],
    },
    {
      t: "Money",
      items: ["Bank and savings accounts — which bank, which branch", "Pensions, retirement and investment accounts", "Mortgage, loans and credit cards", "Last two years of tax returns", "Safe-deposit box — location and who has the key"],
    },
    {
      t: "Insurance",
      items: ["Life insurance — policy number and beneficiary", "Health insurance cards and plan details", "Home or renters insurance", "Car insurance and registration", "Renewal dates for each policy"],
    },
    {
      t: "Home & property",
      items: ["Deeds, leases and title documents", "Utilities and who they're billed to", "Warranties and manuals for big purchases", "Receipts for anything over a few hundred dollars", "Vehicle titles"],
    },
    {
      t: "Digital life",
      items: ["Where passwords are kept (manager, notebook, both)", "Email accounts and recovery phone", "Phone PIN and who may unlock it", "Photo libraries and cloud storage", "Subscriptions that renew automatically"],
    },
    {
      t: "People to call",
      items: ["Attorney or solicitor", "Accountant or tax preparer", "Financial advisor", "Doctor and pharmacist", "The one friend who knows where everything is"],
    },
  ],
  footer: "Each item on this list has a home in HearthVault. Drop in the paper; it comes back named, dated and filed — and the renewal dates become reminders.",
};
